module.exports = __webpack_public_path__ + "media/images/icons/flags/EE-18a04fe87b5ba5de4fe1b4d3147662e1.svg";